export const uf = (value) => {
  if(['', 'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'].indexOf(value) > -1) {
    return true
  }

  return false
}

export const classifiers = (value) => {
  const match = value.match(/^((((\d+) *,* *)*(\d+)))$/g)

  if(!value || match) return true

  return false
}
